import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { tspan } from '../utils/i18n';
import styled, { css } from 'styled-components';

const WaveContainer = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    margin: ${ props => props.play  ? 'auto 0 0 0 !important' : 'auto'};
    left: 0;
    height: ${props => props.recordingScreen && '102px'};

    #waveform {
        // overflow: hidden;
        flex: 1;

        display: block;
        position: relative;
        height: 100%;
        width: 75%;
        margin: 0 auto;

        wave {
            ${props => props.pluginMode && css`
                max-height: 6.4rem;
            `}
        }
    }
    .recwave {
        // overflow: hidden;
        flex: 1;

        display: block;
        position: relative;
        height: 100%;
        width: 75%;
        margin: 0 auto;

        wave {
            ${props => props.pluginMode && css`
                max-height: 6.4rem;
            `}
        }
    }

    .details {
        flex: 1;
        width: 100%;

        display: flex;
        flex-direction: column;

        ${props => props.pluginMode && css`
            margin-bottom: 0rem;
        `}

        align-items: center;
        justify-content: space-evenly;

        .max-recording-length {
            height: 1rem;
            /* padding: 0.25rem 0; */
            font-family: Lato;
            font-size: 0.675rem;
            color: #969696;

            strong {
                color: #656565;
            }
        }

        .progress-bar {
            display: block !important;
            margin: 0 auto;
            
            width: 70%;
            height: 8px !important;
            /* Reduced size in plugin mode */
            ${props => props.pluginMode && css`
                width: 70%;
                height: 8px !important;
            `}

            background-color: #ddd;
            border-radius: 16px;

            .progress-fill {
                width: 0%;
                height: 100%;
                border-radius: 16px;
            }
        }
    }

    .hide {
        display: none;
    }
`;

export default class Waveform extends Component {
    static propTypes = {
        // Display the waveform details (recording time)
        details: PropTypes.bool,

    }

    componentDidMount() {
        this.props.toggleLoader()
    }

    timeLimitString(secondsLimit) {
        let resultM = 0, // In minutes
            resultS = secondsLimit; // In seconds

        // Starting with 2 minutes
        if (resultS > 119) {
            resultM = Math.floor(resultS / 60); // In minutes
            resultS = resultS % 60; // Remainder seconds
        }

        return `${resultM ? (resultM + ' minutes ') : ''}${resultS ? (resultS + ' seconds') : ''}`
    }

    render() {
        const { details, hidden, progress, pluginMode, maximumSecondsLength, className,
            progressBarPrimaryColor, progressBarSecondaryColor, recordingScreen, isPublicHosted, sourceType } = this.props;

        return (
            <WaveContainer className={className} pluginMode={pluginMode} play={this.props.play} recordingScreen={recordingScreen}>
                <div className={`details ${details ? '' : 'hide'}`}>
                    <div className="max-recording-length">
                        {isPublicHosted && <span style={{verticalAlign: "middle"}}>Min recording length:<strong> 5 seconds - </strong></span>}
                        {tspan('recording-max-len', { length: <strong> {this.timeLimitString(maximumSecondsLength)}</strong> })}
                    </div>
                    <div className="progress-bar">
                        <div className="progress-fill" style={{
                            backgroundImage: `linear-gradient(to right, ${progressBarPrimaryColor} ,${progressBarSecondaryColor})`,
                            width: (progress * 100) + "%"
                        }}></div>
                    </div>
                </div>
                {sourceType === 'Recording'
                    ? <div className="recwave" />
                    : <div id="waveform" className={hidden ? 'hide' : ''} />}
            </WaveContainer>
        )
    }
}
